export const Patterns = {
	numericAccount: '[0-9?]',
	alphaNumericAccount: '[a-zA-Z0-9?]'
};
